import { useI18nListener } from 'hooks/use-i18n-listener.hook';
import { useDispatch } from 'react-redux';
import { i18nActions } from 'redux/i18n/i18n.slice';

const AfterRedux = () => {
  const dispatch = useDispatch();
  useI18nListener('languageChanged', lng => {
    dispatch(i18nActions.setLocale(lng));
  });

  return null;
};
export default AfterRedux;
